<template>
    <article>
		<div class="form" ref="pdfContent" id="invoiceform">    
			<table class="welcome-wrap">
				<tr>
					<td colspan="3">
						<!-- <img :src="require('@/assets/logo.png')" style="margin-top: 18PX;width:40%;"> -->
						<ul style="margin-top: 15PX;">
							<li style="font-size:17px;color:#000;margin-bottom:5px;">From: 
								<span style="font-size:17px;color:#000;margin-left: 26px;" id="from-company-name">{{ `${PdfData.from_company_name}` }}</span>
							</li>
							<li style="font-size:18px;color:#000;margin-bottom:5px;">      
								<span style="font-size:16px;color:#000;margin-left: 75px;margin-bottom:5px;display: block;line-height: 23px;" id="from-address">{{ `${PdfData.from_address}` }}</span>
							</li>
							<li style="font-size:18px;color:#000;margin-bottom:5px;">	  
								<span style="font-size:16px;color:#000;margin-left: 75px;margin-bottom:5px;" id="from-city">{{ `${PdfData.from_city}` }}</span>
							</li>
							<li style="margin-bottom:5px;">      
								<span style="font-size:16px;color:#000;margin-left: 75px;" id="from-country">{{ `${PdfData.from_country}` }}</span>
							</li>
							<li>      
								<span style="font-size:16px;color:#000;margin-left: 75px;margin-bottom:5px;" id="from-gstin"></span>
							</li>
						</ul>
						<ul style="margin-top: 15PX;">
							<li style="font-size:17px;color:#000;margin-bottom:5px;">Bill to: 
								<span style="font-size:17px;color:#000;margin-left: 26px;" id="user-name"> {{`${$store.state.currentUserData.first_name}`}}</span>
							</li>
							<li style="font-size:18px;color:#000;margin-bottom:5px;">      
								<span style="font-size:16px;color:#000;margin-left: 75px;margin-bottom:5px;line-height: 23px;" id="user-address">{{`${$store.state.currentUserData.address1},${$store.state.currentUserData.address2}`}}</span>
							</li>
							<li>      
								<span style="font-size:16px;color:#000;margin-left: 75px;margin-bottom:5px;line-height: 23px;" id="user-city-state">{{`${$store.state.currentUserData.cityName},${$store.state.currentUserData.stateName}`}}</span>
							</li>
							<li>      
								<span style="font-size:16px;color:#000;margin-left: 75px;margin-bottom:5px;line-height: 23px;" id="user-country">{{`${$store.state.currentUserData.countryName}`}}</span>
							</li>
							<li>      
								<span style="font-size:16px;color:#000;margin-left: 75px;margin-bottom:5px;line-height: 23px;" id="user-gstin"></span>
							</li>
						</ul>
					</td>
					<td colspan="3">
						<h4 style="text-align:center;background-color:#eee;padding:20px;font-size:24px;font-weight:600;" id="pdf-title">INVOICE</h4>
						<table>
							<tbody>
								<tr>
									<td style="font-size:14px;">INVOICE #</td>
									<td style="font-size:14px;text-align:right;" id="invoice">{{`${PdfData.invoice}`}}</td>
								</tr>
								<tr>
									<td style="font-size:14px;">DATE</td>
									<td style="font-size:14px;text-align:right;" id="date">{{`${PdfData.date}`}}</td>
								</tr>
								<tr>
									<td style="font-size:14px;">TOTAL AMOUNT</td>
									<td style="font-size:14px;text-align:right;" id="total-amount">{{`${PdfData.total_amount}`}}</td>
								</tr>
								<tr>
									<td style="font-size:14px;"><b>TOTAL DUE</b></td>
									<td style="font-size:14px;text-align:right;" id="total-due-amount"><b>{{`${PdfData.total_due_amount}`}}</b></td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</table>
			<table class="inventory">
				<thead>
					<tr>
						<th colspan="5" style="padding:15px;">
							<span style="font-size:16px;"><b>DESCRIPTION / MEMO</b></span>
						</th>
						<th colspan="1" style="padding:15px;">
							<span style="font-size:16px;"><b>AMOUNT</b></span>
						</th>
					</tr>
				</thead>
				<tbody>
                    <tr>
                        <td colspan="5" style="padding:15px;"><span>{{PdfData.data.description}}</span></td>
                        <td colspan="1" style="text-align:right;padding:15px;"><span>{{PdfData.data.amount_balance_}}</span></td>
                    </tr>
                    <tr>
                        <td colspan="5" style="padding:15px;"><span>TOTAL AMOUNT:</span></td>
                        <td colspan="1" style="text-align:right;padding:15px;"><span>{{PdfData.data.amount_balance}}</span></td>
                    </tr>
				</tbody>
				<tfoot>
					<tr>
						<td colspan="3" style="padding:15px;border:0px;"></td>
						<td colspan="3" style="text-align:left;padding:15px 0px;border:0px;">
							<h4 style="text-align:center;background-color:#eee;padding:12px;font-size:18px;font-weight:600;">REMIT TO</h4>
							<ul style="margin-top: 15PX;">
								<li style="font-size:18px;color:#000;margin-bottom:5px;">      
									<span style="font-size:16px;color:#000;margin-bottom:5px;">{{`${$store.state.InvoiceFromDetails.company_name}`}}</span>
								</li>
								<li style="font-size:18px;color:#000;margin-bottom:5px;">	  
									<span style="font-size:16px;color:#000;margin-bottom:5px;" id="address">{{`${$store.state.InvoiceFromDetails.address} , ${$store.state.InvoiceFromDetails.zipcode}`}}</span>
								</li>
								<li style="font-size:18px;color:#000;margin-bottom:5px;">      
									<span style="font-size:16px;color:#000;" id="city">{{`${$store.state.InvoiceFromDetails.city}`}}</span>
								</li>
								<li style="font-size:18px;color:#000;margin-bottom:5px;">      
									<span style="font-size:16px;color:#000;margin-bottom:5px;" id="country">{{`${$store.state.InvoiceFromDetails.country}`}}</span>
								</li>
							</ul>
						</td>
					</tr>
                    <!-- <tr>
                        <button @click="generatePDF()">Generate PDF</button>
                    </tr> -->
				</tfoot>
			</table>
		</div>
    </article>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.9.2/html2pdf.bundle.js"></script>
<script>
    export default {
        data() {
            return {
                PdfData       : {
                    invoice             : '',
                    date                : '',
                    total_amount        : '',
                    total_due_amount    : '',
                    pdf_title           : '',
                    from_company_name   : '',
                    from_address        : '',
                    from_city           : '',
                    from_country        : '',
                    data                : {
                        description         : '',
                        amount_balance_     : '',
                        amount_balance      : '',
                    },
                },
            }
        },
        props:['pdfDataProp'],
        methods: {
            // this fun is for to create invoice file into pdf
            async generatePDF(data) {
                var that = this;
                var makepdf = document.getElementById("invoiceform");
                var opt = {
                    margin:       0.5,
                    filename:     this.PdfData.invoice,
                    image:        { type: 'jpeg', quality: 0.98 },
                    html2canvas:  { scale: 2 },
                    jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' , height: 8.5, width: 11},
                    viewportSize: { width: 1356, height: 768 }
                    
                }; 
                html2pdf().set(opt).from(makepdf).save().then(function () {
                    alert('pdf success')
                    that.$emit('changeGeneratePdfStatus');
                });
            },

            // this fun is for to set invoice data
            async setInvoiceData(data){
                var refId = "QP"+data.type.charAt(0)+data.details.payment_id;
                this.PdfData = {
                    ...this.PdfData,
                    invoice : refId,
                    date    : `${data.date}`,
                    total_amount    : `${data.amount_balance}`,
                    total_due_amount    : `${data.amount_balance}`,
                    data : {
                        description         : data.description,
                        amount_balance_     : data.amount_balance_,
                        amount_balance      : data.amount_balance,
                    },
                }
                if(data.type == "Escrow Refund" || data.type == "Payment" || data.type == "Invoice" || data.type == "Service Fee" || data.type == "Withdrawal" || data.type == "Pan Card" || data.type == "GST"){
                    this.PdfData.pdf_title = 'INVOICE';
                    if(data.type == "Service Fee" || data.type == "Withdrawal" || data.type == "Pan Card" || data.type == "GST"){
                        this.PdfData.from_company_name = this.$store.state.InvoiceFromDetails.company_name;
                    }else{
                        if(data.details.frombilling.profileType == 1 || data.details.frombilling.profileType == 2){
                            this.PdfData.from_company_name = data.details.frombilling.company_name;
                        }else{
                            this.PdfData.from_company_name = data.details.frombilling.first_name;
                        }
                        this.PdfData.from_address   = `${data.details.frombilling.address1},${data.details.frombilling.zipcode}`;
                        this.PdfData.from_city      = data.details.frombilling.city_name;
                        this.PdfData.from_country   = data.details.frombilling.country_name;
                    }
                }else if(data.type == "Marketplace Fee" || data.type == "Funded to escrow") {
                    this.PdfData.pdf_title          = 'RECEIPT';
                    this.PdfData.from_company_name  = this.$store.state.InvoiceFromDetails.company_name;
                }
                await this.$nextTick(); // Wait for Vue to update the DOM
                this.generatePDF(data); // Generate PDF after the data is fully updated
            }
        },
        watch: {
            async pdfDataProp(data) {
                if (data && Object.keys(data).length > 0) {
                    console.log("PDF Data Updated:", data);
                    // this.setInvoiceData(newValue);
                    var refId = "QP"+data.type.charAt(0)+data.details.payment_id;
                    this.PdfData = {
                        ...this.PdfData,
                        invoice : refId,
                        date    : `${data.date}`,
                        total_amount    : `${data.amount_balance}`,
                        total_due_amount    : `${data.amount_balance}`,
                        data : {
                            description         : data.description,
                            amount_balance_     : data.amount_balance_,
                            amount_balance      : data.amount_balance,
                        },
                    }
                    if(data.type == "Escrow Refund" || data.type == "Payment" || data.type == "Invoice" || data.type == "Service Fee" || data.type == "Withdrawal" || data.type == "Pan Card" || data.type == "GST"){
                        this.PdfData.pdf_title = 'INVOICE';
                        if(data.type == "Service Fee" || data.type == "Withdrawal" || data.type == "Pan Card" || data.type == "GST"){
                            this.PdfData.from_company_name = this.$store.state.InvoiceFromDetails.company_name;
                        }else{
                            if(data.details.frombilling.profileType == 1 || data.details.frombilling.profileType == 2){
                                this.PdfData.from_company_name = data.details.frombilling.company_name;
                            }else{
                                this.PdfData.from_company_name = data.details.frombilling.first_name;
                            }
                            this.PdfData.from_address = `${data.details.frombilling.address1},${data.details.frombilling.zipcode}`;
                            this.PdfData.from_city = data.details.frombilling.city_name;
                            this.PdfData.from_country = data.details.frombilling.country_name;
                        }
                    }else if(data.type == "Marketplace Fee" || data.type == "Funded to escrow") {
                        this.PdfData.pdf_title = 'RECEIPT';
                        this.PdfData.from_company_name = this.$store.state.InvoiceFromDetails.company_name;
                    }
                    await this.$nextTick(); // Wait for Vue to update the DOM
                    // Set the flag indicating that the data is now ready
                }
            }
        },
        mounted(){
            document.querySelector('script[src="https://js.stripe.com/v3/"]')
            alert('asd')
        }
    }
</script>
<style scoped>
    h1 {
        font: bold 100% sans-serif;
        letter-spacing: 0.5em;
        text-align: center;
        text-transform: uppercase;
    }
    table {
        font-size: 75%;
        table-layout: fixed;
        width: 100%;
    }
    table {
        border-collapse: separate;
        border-spacing: 2px;
    }
    th,
    td {
        border-width: 1px;
        padding: 0.5em;
        position: relative;
        text-align: left;
    }
    th,
    td {
        border-radius: 0.25em;
        border-style: solid;
    }
    th {
        background: #eee;
        border-color: #bbb;
    }

    td {
        border-color: #ddd;
    }
    html {
        font: 16px/1 "Open Sans", sans-serif;
        overflow: auto;
        padding: 0.5in;
    }
    html {
        background: #999;
        cursor: default;
    }

    body {
        box-sizing: border-box;
        /*height: 11in;*/
        margin: 0 auto;
        overflow: hidden;
        padding: 0.5in;
        width: 8.5in;
    }
    body {
        background: #fff;
        border-radius: 1px;
        box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
    }
    header {
        margin: 0 0 3em;
    }
    header:after {
        clear: both;
        content: "";
        display: table;
    }
    header h1 {
        background: #000;
        border-radius: 0.25em;
        color: #fff;
        margin: 0 0 1em;
        padding: 0.5em 0;
    }
    header address {
        float: left;
        font-size: 75%;
        font-style: normal;
        line-height: 1.25;
        margin: 0 1em 1em 0;
    }
    header address p {
        margin: 0 0 0.25em;
    }
    header span,
    header img {
        display: block;
        float: right;
    }
    header span {
        margin: 0 0 1em 1em;
        max-height: 25%;
        max-width: 60%;
        position: relative;
    }
    header img {
        max-height: 100%;
        max-width: 100%;
    }
    header input {
        cursor: pointer;
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
        height: 100%;
        left: 0;
        opacity: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
    article,
    article address,
    table.meta,
    table.inventory {
        margin-bottom: 20px;
    }
    article:after {
        clear: both;
        content: "";
        display: table;
    }
    article address {
        float: left;
        font-size: 125%;
        font-weight: bold;
    }
    table.meta,
    table.balance {
        float: right;
        width: 36%;
    }
    table.meta:after,
    table.balance:after {
        clear: both;
        content: "";
        display: table;
    }
    table.meta th {
        width: 40%;
    }
    table.meta td {
        width: 60%;
    }
    table.inventory {
        clear: both;
        width: 100%;
    }
    table.inventory th {
        font-weight: bold;
        text-align: left;
    }
    table.inventory td:nth-child(1) {
        width: 26%;
    }
    table.inventory td:nth-child(2) {
        width: 38%;
    }
    table.inventory td:nth-child(3) {
        width: 12%;
    }
    table.inventory td:nth-child(4) {
        width: 12%;
    }
    table.inventory td:nth-child(5) {
        width: 12%;
    }
    table.balance th,
    table.balance td {
        width: 50%;
    }
    table.balance td {
        text-align: right;
    }
    aside h1 {
        border: none;
        border-width: 0 0 1px;
        margin: 0 0 1em;
    }
    aside h1 {
        border-color: #999;
        border-bottom-style: solid;
    }
    .add,
    .cut {
        border-width: 1px;
        display: block;
        font-size: 0.8rem;
        padding: 0.25em 0.5em;
        float: left;
        text-align: center;
        width: 0.6em;
    }
    .add,
    .cut {
        background: #9af;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        background-image: -moz-linear-gradient(#00adee 5%, #0078a5 100%);
        background-image: -webkit-linear-gradient(#00adee 5%, #0078a5 100%);
        border-radius: 0.5em;
        border-color: #0076a3;
        color: #fff;
        cursor: pointer;
        font-weight: bold;
        text-shadow: 0 -1px 2px rgba(0, 0, 0, 0.333);
    }
    .add {
        margin: -2.5em 0 0;
    }
    .add:hover {
        background: #00adee;
    }
    .cut {
        opacity: 0;
        position: absolute;
        top: 0;
        left: -1.5em;
    }
    .cut {
        -webkit-transition: opacity 100ms ease-in;
    }
    tr:hover .cut {
        opacity: 1;
    }
    @media print {
        * {
            -webkit-print-color-adjust: exact;
        }
        html {
            background: none;
            padding: 0;
        }
        body {
            box-shadow: none;
            margin: 0;
        }
        span:empty {
            display: none;
        }
        .add,
        .cut {
            display: none;
        }
    }
    @page {
        margin: 0;
    }
    .personal-details {
        margin-bottom: 20px;
    }
    .personal-details th h1 {
        text-align: left;
    }
    .personal-details th h1 span {
        letter-spacing: 0px;
        font-size: 16px;
        font-weight: 500;
    }
    .personal-details th {
        border: 1px solid #eee;
        background-color: transparent;
    }
    .personal-details th .label {
        font-weight: 100;
        font-size: 13px;
        color: #898989;
        margin-bottom: 5px;
    }
    .personal-details th span {
        font-weight: 400;
        font-size: 16px;
        color: #000;
    }
    .welcome-wrap {
        margin-bottom: 20px;
    }
    .welcome-wrap tr td {
        border: 0px;
    }
    .welcome-wrap .total-patients-box {
        border: 1px solid #dbdbdb;
        text-align: center;
        background-color: #eee;
    }
    .welcome-wrap .total-patients-box h3 {
        margin-top: 6px !important;
    }
    .welcome-wrap tr td img {
			width: 88px;
			height: 30px;
			text-align: center;
			margin: 0;
    }
    .welcome-wrap tr td h3 {
			font-size: 22px;
			margin-top: 10px;
			font-weight: 600;
			margin-bottom: 2px;
    }
    .welcome-wrap tr td h4 {
			font-size: 18px;
			margin-top: 10px;
			font-weight: 400;
			margin-bottom: 2px;
			color: #333;
    }
    .welcome-wrap tr td h5 {
			font-size: 14px;
			margin-top: 5px;
			font-weight: 500;
			margin-bottom: 2px;
			color: #333;
    }
    .welcome-wrap tr td h5 span {
			font-size: 14px;
			margin-top: 5px;
			font-weight: 500;
			margin-bottom: 2px;
    }
    .welcome-wrap tr td h6 {
			font-size: 13px;
			margin-top: 5px;
			font-weight: 300;
			margin-bottom: 2px;
			color: #5b5b5b;
    }
    .welcome-wrap tr td p {
			font-size: 13px;
			margin-top: 5px;
			font-weight: 300;
			margin-bottom: 2px;
			color: #5b5b5b;
    }
    .welcome-wrap tr td span {
			font-size: 16px;
			color: #898989;
			font-weight: 100;
    }
    .pdf-table th {
			background: transparent !important;
			border-color: transparent !important;
    }
    .pdf-table th h1 {
			text-align: left;
    }
    .btn-theme {
		border-radius: 6px!important;
		background-color: #F2613C!important;
		box-shadow: 0 10px 25px 0 rgb(0 0 0 / 10%)!important;
		border: 1px solid #F2613C!important;
		color: #ffffff!important;
		font-family: "Source Sans Pro"!important;
		font-size: 14px!important;
		font-weight: 600!important;
		line-height: 20px!important;
		text-align: center!important;
		padding: 8px 12px!important;
    }
    .btn-theme:hover {
		border-radius: 6px!important;
		background-color: #FFFFFF!important;
		box-shadow: 0 10px 25px 0 rgb(0 0 0 / 10%);
		border: 1px solid #F2613C!important;
		color: #F2613C!important;
		font-family: "Source Sans Pro"!important;
		font-size: 14px!important;
		font-weight: 600!important;
		line-height: 20px!important;
		text-align: center!important;
		padding: 8px 12px!important;
    }
</style>
